import { createEffectFn } from '@ngneat/effects';
import { catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap } from 'rxjs';
import { AuditOfferServiceGroupedActionsDto, OfferActionArray, OfferActionArrayLight, OfferFormalizationAction } from './audit-offer.model';
import { auditsOfferService } from './audit-offer.services';

interface AuditsOfferParams {
  auditAction?: OfferActionArray;
  auditId: string;
}

interface AuditsOfferFormalizationParams {
  auditsFormalizationAction?: OfferFormalizationAction;
  auditId: string;
}

const isOfferActionArray = (auditAction: OfferActionArray) =>
  auditAction.canBeRequested !== undefined || auditAction.enableSchedule !== undefined || auditAction.clientWasteName !== undefined;


export const AuditsOfferEffect = createEffectFn((params$: Observable<AuditsOfferParams>) => {
  return params$.pipe(
    debounceTime(500),
    distinctUntilChanged(),
    switchMap(({auditAction, auditId}) => {

      console.log(auditAction);

     const observable = isOfferActionArray(auditAction as OfferActionArray) ?
     auditsOfferService.PATCHServiceGroupedActions(auditAction as AuditOfferServiceGroupedActionsDto) :
     auditsOfferService.PATCHUpdateValidate(auditAction?.auditOfferIds[0] as number , auditAction as OfferActionArrayLight);

       return observable.pipe(
         switchMap(() => auditsOfferService.GETAuditOffersByAudit(auditId as string)),
         catchError(() => EMPTY),
       );
    })
  );
});

export const AuditsOfferFormalizationEffect = createEffectFn((params$: Observable<AuditsOfferFormalizationParams>) => {
  return params$.pipe(
    debounceTime(500),
    distinctUntilChanged(),
    switchMap(({auditsFormalizationAction, auditId}) => auditsOfferService.PATCHPriceGroupedActions(auditsFormalizationAction as OfferFormalizationAction)
       .pipe(
         switchMap(() => auditsOfferService.GETAuditOffersByAudit(auditId as string)),
         catchError(() => EMPTY),
       )
      )
  );
});